// PGSS-5748: the label as it printed before the 4" x 6" box label (psg-frontend #2739), kept unchanged as the
// "Classic label" fallback on the supplier's Shipping Label page. It has no box code or QR code.
import { Card, CardContent, Typography } from "@mui/material";
import clsx from "clsx";
import { getCustomerBasedProfile } from "app/main/apps/common/AuraFunctions";

function ClassicShipmentLabelContent({
  shippingLabel,
  labelRef,
  isPrinting,
  totalLabels,
}) {
  const getClassName = (index) => {
    if (isPrinting && index > 0 && index % 5 === 0) {
      return "mb-96";
    }
    if (
      isPrinting &&
      index !== totalLabels - 1 &&
      totalLabels > 2 &&
      (index + 1) % 2 === 0
    )
      return "mb-48";
    return "";
  };

  return (
    <div className="mt-30 m-6 w-full shipping-label" ref={labelRef}>
      {shippingLabel?.shipping_label?.orders.map((o, index) => (
        <Card
          key={o.orderId}
          variant="outlined"
          className={clsx("w-full mt-20 p-0", getClassName(index))}
        >
          <CardContent className="p-0 !pb-0">
            <div className="flex border-2 !border-black justify-evenly border-radius rounded-2xl">
              <div className="items-center text-center border-r-2 !border-black w-224">
                <div className="border-b-2 !border-black flex items-center justify-center font-bold min-h-60 max-h-60">
                  <img
                    src={getCustomerBasedProfile.companyLogo}
                    alt="logo"
                    className="object-cover h-32"
                  />
                </div>
                <div className="flex text-center h-full">
                  <div className="border-r-2 !border-black w-full">
                    <Typography className="font-bold border-b-2 !border-black pb-2 text-[20px]">
                      LEN
                    </Typography>
                    <Typography className="text-[20px]">{o.length}</Typography>
                  </div>
                  <div className="border-r-2 !border-black w-full">
                    <Typography className="font-bold border-b-2 !border-black pb-2 text-[20px]">
                      THK
                    </Typography>
                    <Typography className="text-[20px]">{o.width}</Typography>
                  </div>
                  <div className="w-full">
                    <Typography className="font-bold border-b-2 !border-black pb-2 text-[20px]">
                      HGT
                    </Typography>
                    <Typography className="text-[20px]">{o.height}</Typography>
                  </div>
                </div>
              </div>

              <div className="items-center border-r-2 !border-black w-1/2">
                <div className="font-bold mb-2 text-center border-b-2 !border-black min-h-60 max-h-60">
                  <Typography variant="h5" className="">
                    {shippingLabel?.shipping_label?.company_name}
                  </Typography>
                  <Typography className="text-[20px] whitespace-nowrap">
                    {shippingLabel?.shipping_label?.company_address}
                  </Typography>
                </div>
                <div className="flex  text-center h-full">
                  <div className="border-r-2 !border-black w-full">
                    <Typography className="font-bold border-b-2 !border-black text-[20px]">
                      Color
                    </Typography>
                    <Typography className="text-[20px] whitespace-nowrap">
                      {o.color}
                    </Typography>
                  </div>
                  <div className="border-r-2 !border-black w-full">
                    <Typography className="font-bold border-b-2 !border-black text-[20px]">
                      Shape
                    </Typography>
                    <Typography className="text-[20px]">{o.type}</Typography>
                  </div>
                  <div className="w-full">
                    <Typography className="font-bold border-b-2 !border-black text-[20px]">
                      Finish
                    </Typography>
                    <Typography className="text-[20px]">{o.polish}</Typography>
                  </div>
                </div>
              </div>

              <div className="items-center border-r-2 !border-black w-1/6">
                <Typography
                  variant="h5"
                  className="font-bold mb-2 flex items-center justify-center border-b-2 !border-black min-h-60 max-h-60"
                >
                  {o.box_number}
                </Typography>
                <div className="flex justify-evenly text-center h-full">
                  <div className="border-r-2 !border-black-1 !border-black text-center w-full h-full ">
                    <Typography className="font-bold border-b-2 !border-black text-[20px]">
                      Holes
                    </Typography>
                    <Typography className="text-[20px]">Nil</Typography>
                  </div>
                  <div className="text-center w-full">
                    <Typography className="font-bold border-b-2 !border-black text-[20px]">
                      QTY
                    </Typography>
                    <Typography className="text-[20px]">
                      {o.quantity}
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="text-center w-1/4">
                <Typography
                  variant="h5"
                  className="font-bold mb-2 flex items-center justify-center border-b-2 !border-black min-h-60 max-h-60"
                >
                  {shippingLabel?.shipping_label.container_number}
                </Typography>
                <div className="flex justify-evenly h-full">
                  <div className="border-r-2 !border-black text-center w-full">
                    <Typography className="font-bold border-b-2 !border-black text-[20px]">
                      Decedent
                    </Typography>
                    <Typography className="text-[20px]">
                      {o.decedents}
                    </Typography>
                  </div>
                  <div className="whitespace-nowrap w-full">
                    <Typography className="font-bold border-b-2 !border-black text-[20px]">
                      Order No.
                    </Typography>
                    <Typography className="text-[20px]">
                      {o.order_no ? `#${o.order_no}` : ""}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
export default ClassicShipmentLabelContent;
